import { useSearchParams } from 'react-router-dom'
import { useCallback, useMemo } from 'react'

export interface ServiciosFiltrosState {
  busqueda: string
  categoria: string
  estado: string
}

export const FILTROS_SERVICIOS_INICIALES: ServiciosFiltrosState = {
  busqueda: '',
  categoria: 'todos',
  estado: 'todos',
}

/**
 * Hook para sincronizar los filtros de servicios con los search params de la URL.
 * Permite persistir filtros al refrescar y compartir URLs con filtros aplicados.
 *
 * @example
 * const { filtros, setFiltros } = useServiciosFiltrosURL()
 */
export function useServiciosFiltrosURL() {
  const [searchParams, setSearchParams] = useSearchParams()

  // Leer filtros desde URL
  const filtros = useMemo<ServiciosFiltrosState>(() => ({
    busqueda: searchParams.get('q') || FILTROS_SERVICIOS_INICIALES.busqueda,
    categoria: searchParams.get('categoria') || FILTROS_SERVICIOS_INICIALES.categoria,
    estado: searchParams.get('estado') || FILTROS_SERVICIOS_INICIALES.estado,
  }), [searchParams])

  // Actualizar filtros en URL
  const setFiltros = useCallback((nuevosFiltros: ServiciosFiltrosState) => {
    const params = new URLSearchParams()

    // Solo agregar params si difieren del default
    if (nuevosFiltros.busqueda && nuevosFiltros.busqueda !== FILTROS_SERVICIOS_INICIALES.busqueda) {
      params.set('q', nuevosFiltros.busqueda)
    }
    if (nuevosFiltros.categoria && nuevosFiltros.categoria !== FILTROS_SERVICIOS_INICIALES.categoria) {
      params.set('categoria', nuevosFiltros.categoria)
    }
    if (nuevosFiltros.estado && nuevosFiltros.estado !== FILTROS_SERVICIOS_INICIALES.estado) {
      params.set('estado', nuevosFiltros.estado)
    }

    setSearchParams(params, { replace: true })
  }, [setSearchParams])

  return { filtros, setFiltros }
}
